import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import trash from "./../../../Assets/Images/trash.png";
import add from "./../../../Assets/Images/add.png";
import ReactLoading from "react-loading";
import toast from "react-hot-toast";
import Modal from "antd/es/modal/Modal";

//Components
import {
  toastStyle,
} from "../../../Helpers/Utils/Common";
import {
  createCategories,
  updateCategories,
  getAllCategories,
} from "../../../Helpers/apiCalls/Manage/Categories";
import Footer from '../../../Components/Footer/Footer';

function Category({ category, level, onAddSubcategory, onDelete, onSubcategoryChange, parentCategoryName, subcategoryIndex }) {
  const [subcategories, setSubcategories] = useState([]);
  const [localCategory, setLocalCategory] = useState(category);

  // console.log("Category outside useEffect:", category);
  useEffect(() => {
    setLocalCategory(category);
    setSubcategories(category.subcategories);
    console.log("Rendering Category:", category);
  }, [category]);

  const handleAddSubcategory = () => {
    const newSubcategory = { name: '', subcategories: [] };
    setSubcategories(prevSubcategories => [...prevSubcategories, newSubcategory]);
    onAddSubcategory(localCategory, newSubcategory); // Pass parent category here
  };

  const handleDelete = () => {
    onDelete(localCategory);
  };

  const handleSubcategoryChange = (e) => {
    const newName = e.target.value;
    const updatedCategory = { ...localCategory, name: newName };
    // var subIndex = parseInt(subcategoryIndex.split("-")[0])
    setLocalCategory(updatedCategory);
    onSubcategoryChange(parentCategoryName, subcategoryIndex, newName);
  };

  return (
    <div style={{ marginLeft: `${level * 10}px` }}>
      {level <= 5 && (
        <>
          <Row className="nc-modal-custom-row mt-2">
            {
              level > 1 && (
                <Col xs={8} xl={10}>
                  <Form.Control
                    type="text"
                    name="name"
                    value={localCategory.name}
                    onChange={handleSubcategoryChange}
                    required
                  />
                </Col>
                )
            } 
            {(level === 1 && level < 5) && (
              <Col xs={6} xl={4}>
                <button
                  type="button"
                  className="button-primary me-2 p-2"
                  onClick={handleAddSubcategory}
                >
                  Add subcategory
                </button>
              </Col>
            )}
            <Col xs={4} xl={2} className="d-flex justify-content-end align-items-center">
              {(level > 1 && level < 5) && (
                <div onClick={handleAddSubcategory}>
                  <img src={add} alt="add-subcategory" className="me-3" />
                </div>
              )}
              {level > 1 && (
                <div>
                  <button
                    type="button"
                    className="button-primary me-2 p-2"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                </div>
              )}
            </Col>
          </Row>
        </>
      )}
      {subcategories.map((subcategory, index) => (
        <Category
          key={index}
          subcategoryIndex={index}
          category={subcategory}
          level={level + 1}
          onAddSubcategory={onAddSubcategory}
          onDelete={onDelete}
          onSubcategoryChange={onSubcategoryChange}
          parentCategoryName={localCategory.name} // Pass parent category name to child Category
        />
      ))}
    </div>
  );
}


function FormCategory2() {
  const [categories, setCategories] = useState([{name: "", id: 1, subcategories: []}]);
  const { id } = useParams();
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(true);
  const [isClicked, setIsClicked] = useState(false);
  const [name, setName] = useState("");
  const [subcategoryIndex, setSubcategoryIndex] = useState(0);
  const [key, setKey] = useState("");
  const [categoryKey, setCategoryKey] = useState(0);

  function handleAddCategory () {
    const newCategory = { name: "", subcategories: [] };
    setCategories([...categories, newCategory]);
  };

  const handleCategoryChange = (e, index) => {
    const { name, value } = e.target;
    var data = [...categories]
    data[index][name] = value
    setCategories(data);
  };

  const handleSetKey = (key) => {
    setKey(key)
  };
  
  const handleAddSubcategory = (parentCategory, subcategory) => {
    const updatedCategories = categories.map((category) =>
      addSubcategory(category, parentCategory, subcategory)
    );
    setCategories(updatedCategories);
  };

  const addSubcategory = (category, parentCategory, subcategoryToAdd) => {
    if (category.name === parentCategory.name) {
      return {
        ...category,
        subcategories: [...category.subcategories, subcategoryToAdd]
      };
    } else if (category.subcategories && category.subcategories.length > 0) {
        // IF CATEGORY !== PARENT, MO RECURSE SIYA SULOD SA SUBCATEGORY MAKING THE SUBCAT A CATEGORY
      return {
        ...category,
        subcategories: category.subcategories.map(sub =>
          addSubcategory(sub, parentCategory, subcategoryToAdd)
        )
      };
    }
    return category;
  };

  // SUBCATEGORY ON CHANGE HANDLER AND RECURSION
  const handleSubcategoryChange = (parentCategoryName, subcategoryIndex, newName) => {
    const updatedCategories = categories.map((category) =>
      changeSubcategory(category, parentCategoryName, subcategoryIndex, newName)
    );
    setCategories(updatedCategories);
  };

  const changeSubcategory = (category, parentCategoryName, subcategoryIndex, newName) => {
      if (category.name === parentCategoryName) {
        return {
          ...category,
          subcategories: category.subcategories.map((sub, index) => {
            if (index === subcategoryIndex) {
              return { ...sub, name: newName };
            }
            return sub;
          })
        };
      } else if (category.subcategories && category.subcategories.length > 0) {
        // IF CATEGORY !== PARENT, MO RECURSE SIYA SULOD SA SUBCATEGORY MAKING THE SUBCAT A CATEGORY
      return {
        ...category,
        subcategories: category.subcategories.map(sub =>
          changeSubcategory(sub, parentCategoryName, subcategoryIndex, newName)
        )
      };
    }
    return category;
  };

  const handleDelete = (categoryToDelete) => {
    const updatedCategories = deleteCategory(categories, categoryToDelete);
    setCategories(updatedCategories);
    setCategoryKey(prevKey => prevKey + 1); // Update the key
  };

  const deleteCategory = (categories, categoryToDelete) => {
    console.log("categories", categories)
    console.log("categoryToDelete", categoryToDelete)
    return categories.filter(category => {
      if (category.name === categoryToDelete.name) {
        return false; // Exclude the category to delete
      }
      if (category.subcategories && category.subcategories.length > 0) {
        // Recursively delete from subcategories
        category.subcategories = deleteCategory(category.subcategories, categoryToDelete);
      }
      return true;
    });
  };

  const logCompleteData = () => {
    console.log("categories", categories);
    console.log("categoryKey", categoryKey);
  };

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"MANAGE ITEM"}
        />
      </div>
      <div className={`container ${inactive ? "inactive" : "active"}`}>
        <div className="row">
          <h1 className="page-title mb-4"> Category</h1>
        </div>

        <div className="edit-form">
          {/* <button
            type="button"
            className="button-primary me-3"
            onClick={logCompleteData}
          >
            Log data
          </button> */}
          {
          categories.map((category, index) => (
            <Row className="nc-modal-custom-row mt-2">
              <Col>
                NAME
                <span className="required-icon">*</span>
                <Form.Control
                  type="text"
                  name="name"
                  defaultValue={category?.name}
                  className="nc-modal-custom-input-edit"
                  onChange={(e) => handleCategoryChange(e, index)}
                  required
                />
              </Col>
              {/* <Col xs={2}>
                <button
                  type="button"
                  className="button-primary me-3"
                  onClick={()=>showModal(true)}
                  // onClick={handleAddSubcategory}
                >
                  Add Subcategory
                </button>
              </Col> */}
            </Row>
          ))
          }
          {categories.map((category, index) => (
            <Category
              // key={category.id}
              subcategoryIndex={index}
              category={category}
              level={1}
              onAddSubcategory={handleAddSubcategory}
              onSubcategoryChange={handleSubcategoryChange}
              onDelete={handleDelete}
              key={categoryKey} // Pass the key as a prop
            />
          ))}

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate("/category")}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary me-3 d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary me-3"
                // onClick={handleSubmit}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}



export default FormCategory2;
